import OrderStatus from '../model/order-status'

const statuses: OrderStatus[] = ['CREATED', 'PURCHASED', 'ARRIVING', 'PROCESSING', 'FINISHED', 'CANCELLED']

export default function parseNumericOrderStatus(numericStatus: number) {
  return statuses[numericStatus - 1]
}
